import hoursMap from 'helpers/hoursMap';

angular.module('gym.calendar').controller('TrainersCtrl', ["$scope", "$state", "$rootScope", "$interval", "$filter", "loadingAnimation", "Trainers", "EmploymentService", "CalendarLastVisitedViewService", "TrainersService", "EventService", "GTMService", "CwStorage", "Availability", "locations", "selectedLocation", "eventTypes", "styles", function($scope, $state, $rootScope, $interval, $filter, loadingAnimation, Trainers, EmploymentService, CalendarLastVisitedViewService, TrainersService, EventService, GTMService, CwStorage, Availability, locations, selectedLocation, eventTypes, styles) {
  var displayCurrentTimeStripe, endTime, getAvailability, getTrainers, getTrainersDebounced, gymConfig, ref, ref1, startTime, tz;
  $scope.permissions = EmploymentService.get().permissions;
  if (!$scope.permissions.manage_other_contacts) {
    $state.go('gym.calendar');
  }
  CalendarLastVisitedViewService.set($state.current.name);
  $scope.date = moment();
  tz = $rootScope.gym.tz;
  gymConfig = $rootScope.gym.gym_config;
  $scope.unableToManageOtherContacts = !$scope.permissions.manage_other_contacts;
  $scope.eventTypes = eventTypes;
  $scope.styles = styles;
  $scope.locations = locations;
  $scope.instructors = TrainersService.get();
  $scope.selectedLocations = _.compact([selectedLocation]);
  $scope.selectedInstructors = [];
  $scope.selectedEventTypes = [];
  $scope.selectedStyles = [];
  GTMService.trackPage('Calendar Trainers');
  startTime = ((ref = gymConfig.calendar_display_hours_override) != null ? ref[0] : void 0) || 4;
  endTime = ((ref1 = gymConfig.calendar_display_hours_override) != null ? ref1[1] : void 0) - 1 || 23;
  $scope.hours = (function() {
    var results = [];
    for (var i = startTime; startTime <= endTime ? i <= endTime : i >= endTime; startTime <= endTime ? i++ : i--){ results.push(i); }
    return results;
  }).apply(this).map(function(num) {
    return hoursMap[num];
  });
  displayCurrentTimeStripe = (function() {
    var calculateStripePosition, currentTimeInterval, minutesInTimeSlot, startOfDay, timeSlotHeight;
    startOfDay = moment().startOf('day').add(startTime, 'hours');
    timeSlotHeight = 25;
    minutesInTimeSlot = 30;
    calculateStripePosition = function() {
      var currentTime, headerHeight, minutesFromStartOfDay;
      headerHeight = window.innerWidth <= 991 ? 42 : 0;
      currentTime = moment();
      minutesFromStartOfDay = currentTime.diff(startOfDay, 'minutes');
      $scope.currentTime = currentTime.format('h:mma');
      return $scope.currentTimePosition = minutesFromStartOfDay / minutesInTimeSlot * timeSlotHeight + headerHeight + 'px';
    };
    calculateStripePosition();
    currentTimeInterval = $interval(function() {
      return calculateStripePosition();
    }, 10000);
    return $rootScope.$on('$stateChangeStart', function() {
      return $interval.cancel(currentTimeInterval);
    });
  })();
  $scope.toDate = function(date) {
    $scope.date = date;
    getTrainers();
    return getAvailability();
  };
  $scope.showAttendees = function(event) {
    return EventService.showAttendees(event);
  };
  $scope.createAppointment = function(event, availability, trainerId) {
    var minutesOfftes, params, time;
    minutesOfftes = Math.floor(event.offsetY / 25) * 30;
    time = availability.startMoment.clone().add(minutesOfftes, 'minutes').format('X');
    params = {
      time: time,
      location_id: availability.location_id,
      trainer_id: trainerId
    };
    return EventService.addAppointment(params);
  };
  getTrainers = function() {
    var params, selectedEventType, selectedInstructor, selectedStyle;
    $scope.title = $scope.date.format('dddd, MMM D, YYYY');
    loadingAnimation.show();
    selectedLocation = $scope.selectedLocations[0] || {};
    selectedInstructor = $scope.selectedInstructors[0] || {};
    selectedEventType = $scope.selectedEventTypes[0] || {};
    selectedStyle = $scope.selectedStyles[0] || {};
    params = {
      start: $scope.date.startOf('day').format('X'),
      end: $scope.date.endOf('day').format('X'),
      location_id: selectedLocation.id,
      event_type_id: selectedEventType.id,
      style_id: selectedStyle.id,
      'trainer_ids[]': selectedInstructor.id
    };
    return Trainers.getList(params).then(function(trainers) {
      loadingAnimation.hide();
      return $scope.trainers = trainers.map(function(trainer) {
        trainer.events = _.filter(trainer.events, function(event) {
          return $scope.date.isSame(moment(event.start, 'YYYY/MM/DD HH:mm'), 'day');
        }).map(function(event) {
          event.isCancelled = !!event.cancelled;
          return event;
        });
        return trainer;
      });
    });
  };
  getAvailability = function() {
    var date, params;
    date = moment($scope.date).format('YYYY-MM-DD');
    params = {
      'filters[start_date]': date,
      'filters[end_date]': date,
      'count': 1000,
      '_': new Date().getTime()
    };
    return Availability.getList(params).then(function(data) {
      var availabilities;
      availabilities = data.plain().map(function(item) {
        item.classroom_name = item.location_name;
        item.start = moment(item.start_at).tz(tz).format('YYYY/MM/DD HH:mm');
        item.end = moment(item.end_at).tz(tz).format('YYYY/MM/DD HH:mm');
        return item;
      });
      return $scope.availabilities = _.groupBy(availabilities, 'user_id');
    });
  };
  $scope.isFiltersAvailable = function() {
    return $scope.locations.length > 1 || $scope.instructors.length > 1;
  };
  getTrainersDebounced = _.debounce(function() {
    return getTrainers();
  }, 300);
  $rootScope.$on('calendar:updated', function() {
    return getTrainers();
  });
  $scope.onLocationsChange = function(locations) {
    var location;
    location = locations[0] || {};
    CwStorage.setItem('selectedLocation', location.id);
    $scope.selectedLocations = locations;
    return getTrainersDebounced();
  };
  $scope.onInstructorsChange = function(instructors) {
    var instructor;
    instructor = instructors[0] || {};
    $scope.selectedInstructors = instructors;
    return getTrainersDebounced();
  };
  $scope.onEventTypesChange = function(eventTypes) {
    $scope.selectedEventTypes = eventTypes;
    return getTrainersDebounced();
  };
  $scope.onStylesChange = function(styles) {
    $scope.selectedStyles = styles;
    return getTrainersDebounced();
  };
  getTrainers();
  return getAvailability();
}]);
